// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.url_url_s4mig {
    font-family: monospace;
    -webkit-user-select: text;
       -moz-user-select: text;
        -ms-user-select: text;
            user-select: text;
    word-wrap: break-word;
}
.url_url_s4mig::before {
    content: '"';
}
.url_url_s4mig::after {
    content: '"';
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-security-manager-modal/url.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".url {\n    font-family: monospace;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n    word-wrap: break-word;\n}\n.url::before {\n    content: '\"';\n}\n.url::after {\n    content: '\"';\n}\n"],"sourceRoot":""}]);
// Exports
export var url = `url_url_s4mig`;
export default ___CSS_LOADER_EXPORT___;
